<template>
    <Carousel class="relative w-full carousel" :opts="{
        align: 'end',
        loop: true,
        watchDrag: allowDrag
    }">
        <CarouselPrevious v-if="showArrows" />
        <CarouselContent>
            <CarouselItem v-for="(slide, index) in model.slides" :key="index" class="carousel-container">
                <img :src="slide.image?.url" :alt="slide.image?.text" class="carousel-image" />
                <div class="carousel-text" v-if="slide.text || slide.buttonLink">
                    <span v-html="slide.text"></span>
                    <Button v-if="slide.buttonLink" as-child><a :href="slide.buttonLink.url">{{ slide.buttonLink.text
                            }}</a></Button>
                </div>
            </CarouselItem>
        </CarouselContent>
        <CarouselNext v-if="showArrows" />
    </Carousel>
</template>
<script lang="ts" setup>
import { Button } from '../ui/button';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '../ui/carousel';
import type { ICarouselProps } from './Carousel.model';

const { model } = defineProps<ICarouselProps>();

const showArrows = model.slides.length > 1 && !model.hideArrows;
const allowDrag = model.slides.length > 1;
const height = model.slides.length > 1 ? "450px" : "auto";
</script>
<style lang="scss" scoped>
.carousel {
    background-color: green;
    z-index: 1;
}

.carousel-container {
    width: 100%;
    min-height: v-bind(height);
    position: relative;
}

.carousel-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.carousel-text {
    position: absolute;
    right: 400px;
    bottom: 250px;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.6);
    color: var(--background);
    font-weight: 800;
    font-size: 2.3rem;
    display: flex;
    flex-direction: column;
    gap: 5px;
}

@media (min-width: 768px) {
    .carousel-container {
        min-height: 450px;
    }
}
</style>